/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "In caricamento"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var itIT = Object.assign(TranslationProviderComponent, {
  translations
});

export { itIT as i };
//# sourceMappingURL=it-IT-DlvYqEeH.js.map
